<template>
  <div class="double12 text-NotoSansLight mx-auto">
    <div class="main w-full">
      <div class="banner pb-8">
        <div class="content max-w-5xl mx-auto z-40 flex justify-center px-4 h-full items-stretch pt-12">
          <div class="w-1/3 px-4">
            <img src="~@/assets/images/double12/ALLMG-PIC.png" class="object-contain h-auto max-w-full mx-auto">
          </div>
          <div class="paper w-1/3 flex items-end">
            <img src="~@/assets/images/double12/MASTER-VISUAL.png" class="object-contain h-auto max-w-full">
          </div>
          <div class="w-1/3 relative px-4">
            <img src="~@/assets/images/double12/WATCH.png" class="h-auto absolute object-contain watch z-40" data-aos="zoom-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
          </div>
        </div>
      </div>
      <div class="award py-1 md:py-3">
        <div class="max-w-5xl mx-auto flex justify-center items-center flex-wrap lg:px-2">
          <img src="~@/assets/images/double12/main_02.png" class="w-full h-auto max-w-full">
        </div>
      </div>
      <div class="magazine px-2 max-w-5xl mx-auto">
        <div class="max-w-5xl mx-auto flex">
          <div class="livePen py-4 md:py-8">
            <div class="title mb-4 md:mb-6">
              <div class="mx-auto z-40 flex justify-center items-center px-4">
                <img src="~@/assets/images/double12/MG-title.png" class="w-max-full z-40 h-auto object-contain">
              </div>
            </div>
            <div class="flex flex-wrap justify-center">
              <div class="w-1/2 md:w-1/3 p-2 md:p-4" v-for="(item, index) in magazine" :key="index">
                <router-link target="_blank" :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }">
                  <img :src="item.img_url" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="80">
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="attention py-6 lg:py-10 text-white text-base lg:text-base mx-auto">
        <div class="gold max-w-5xl mx-auto px-6 md:px-8 lg:px-10 tracking-wider relative z-10">
          <div class="w-full leading-relaxed mb-4 lg:mb-6">
            <h6 class="mb-1 font-bold">◐ 活動時間：</h6>
            <p class="mb-1">2020.12.1 (二) ~ 2020.12.31 (四)</p>
          </div>
          <div class="w-full leading-relaxed mb-4 lg:mb-6">
            <h6 class="mb-1">◐ 抽獎贈品：</h6>
            <p class="mb-1">Samsung Galaxy Fit 2智慧手環，共3名。</p>
          </div>
          <div class="w-full leading-relaxed mb-4 lg:mb-6">
            <h6 class="mb-1">◐ 活動資格：</h6>
            <p class="mb-1">凡於活動期間內，全館單筆訂單消費滿1,212元(包含)以上，即可獲得抽獎機會。</p>
          </div>
          <div class="w-full leading-relaxed mb-4 lg:mb-6">
            <h6 class="mb-1">◐ 得獎公布：</h6>
            <p class="mb-1">將於2020年1月中抽出並於「LiveABC官方網站」及「LiveABC臉書官方粉絲團」公告。</p>
            <p class="text-sm lg:text-base">(領獎時間及領取方式也會一併公告。)</p>
          </div>
          <div class="w-full leading-relaxed">
            <h6 class="mb-1">◐ 注意事項：</h6>
            <p class="mb-1 text-sm">⒈訂單經取消、未付款，將視同放棄抽獎資格。</p>
            <P class="mb-1 text-sm">⒉若因通訊資料有誤、或其他相關因素，以致無法聯絡或寄送獎品予得獎者，將視同放棄得獎資格。</P>
            <P class="mb-1 text-sm">⒊參加者保證所有填寫或提出之資料均為真實且正確，且未冒用或盜用任何第三人之資料。如有不實或不正確之情事，將被取消參加或得獎資格。如因此致本公司無法通知其得獎訊息時，LiveABC互動英語教學集團不負任何責任，且如有致損害於本公司或其他任何第三人，參加者應負一切相關責任。</P>
            <P class="mb-1 text-sm">⒋若因登記資料有誤，或因訂單未付款，得獎資格將被取消，恕不另行通知。</P>
            <P class="mb-1 text-sm">⒌LiveABC互動英語教學集團保有修改、變更或暫停本活動之權利，如有未盡事宜，悉依本公司相關規定或解釋辦理，而得隨時補充公告之；且本公司保留對本活動辦法隨時增加、修改、刪減及最終解釋之權利。修改後之活動內容將於本活動網頁中更新，恕不另行通知。</P>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Double12',
  metaInfo () {
    return {
      title: '雙12！年終感謝祭',
      titleTemplate: null
    }
  },
  data () {
    return {
      magazine: [
        { name: 'ABC', id: 7018, img_url: require('@/assets/images/double12/ORDER-ABC.png') },
        { name: 'LIVE', id: 7028, img_url: require('@/assets/images/double12/ORDER-LIVE.png') },
        { name: 'ALL', id: 7030, img_url: require('@/assets/images/double12/ORDER-ALL.png') },
        { name: 'CNN', id: 7032, img_url: require('@/assets/images/double12/ORDER-CNN.png') },
        { name: 'JP', id: 7034, img_url: require('@/assets/images/double12/ORDER-JP.png') },
        { name: 'HW', id: 7036, img_url: require('@/assets/images/double12/ORDER-HW.png') }
      ]
    }
  },
  components: {
  },
  mixins: [
  ],
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .banner {
    background-image: url('~@/assets/images/double12/main_01.png');
    background-size: cover;
    background-repeat: no-repeat;
    .content {
      background-image: url('~@/assets/images/double12/BALL-UP.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: right 1em top;
      .watch {
        top: 25%;
        @media (max-width: 768px) {
          top: 20%;
        }
        @media (max-width: 425px) {
          top: 15%;
        }
      }
    }
  }
  .award {
    background-color: #c30d23;
  }
.attention {
  background-color: #c30d23;
  .gold {
    background-image: url('~@/assets/images/double12/BALL-DOWN.png');
    background-size: auto;
    background-repeat: no-repeat;
    background-position: right 2em top 2em;
    @media (max-width: 768px) {
      background-position: right .5em top 0;
    }
    @media (max-width: 640px) {
      background-image: none;
    }
    h6 {
      font-weight: 700 !important;
    }
    p {
      font-weight: 300 !important;
      line-height: 28px;
      letter-spacing: 0.1em;
    }
  }
}
</style>
